/*
 * @Description:
 * @Date: 2025-06-23 11:13:28
 */
import InvoiceUninvoicedList from '../components/invoice-uninvoiced-list.vue';
import InvoiceRecordList from '../components/invoice-record-list.vue';
import InvoiceFilingList from '../components/invoice-filing-list.vue';
import InvoiceIndividuaFilinglList from '../components/invoice-individua-filingl-list.vue';
import { InvoiceDjsjList } from '../components/invoice-djsj';

export const TABS = {
  1: { label: '未开票订单', value: 1, cmpt: InvoiceUninvoicedList },
  2: { label: '开票记录', value: 2, cmpt: InvoiceRecordList },
  4: { label: '个体发票上传', value: 4, cmpt: InvoiceIndividuaFilinglList },
  3: { label: '开票备案', value: 3, cmpt: InvoiceFilingList },
  5: { label: '代缴税金', value: 5, cmpt: InvoiceDjsjList }
};

export const INVOICE_TYPE = {
  1: { label: '增值税普通发票', value: 1 },
  2: { label: '增值税专用发票', value: 2 }
};
export const INVOICE_METHODS = {
  0: { label: '纸质发票', value: 0 },
  1: { label: '电子发票', value: 1 }
};
// C端发票状态
export const C_INVOICE_STATUS = {
  0: { label: '未开票', value: 0 },
  1: { label: '待审核', value: 1 },
  2: { label: '已开票', value: 2 },
  3: { label: '已驳回', value: 3 }
};
// 平台发票状态
export const INVOICE_STATUS = {
  [-1]: { label: '申请开票驳回', value: -1 }, // 申请驳回后，无任何操作
  0: { label: '待开票', value: 0 },
  1: { label: '待审核', value: 1 },
  2: { label: '已开票', value: 2 },
  3: { label: '购方已驳回', value: 3 },
  4: { label: '待红冲发票', value: 4 },
  5: { label: '红冲待审核', value: 5 },
  6: { label: '已红冲', value: 6 },
  7: { label: '购方已驳回红冲', value: 7 }
};
export const GT_INVOICE_STATUS = {
  [-2]: { label: '待个体确认', value: -2 },
  8: { label: '待个体确认红冲', value: 8 }
};
export const ALL_INVOICE_STATUS = {
  ...INVOICE_STATUS,
  ...GT_INVOICE_STATUS
};
export const MAIL_TYPE = {
  0: { label: '非邮寄', value: 0 },
  1: { label: '邮寄', value: 1 }
};
export const INVOICE_FUNCTION = {
  1: { label: '蓝票', value: 1 },
  2: { label: '红票', value: 2 }
};
export const INVOICE_AUDIT_TYPE = {
  0: { label: '发票驳回', value: 0 },
  1: { label: '发票通过', value: 1 }
};
// 工业发票状态，改状态可能有问题，应该和C_INVOICE_STATUS一致
export const OFFLINE_INVOICE_STATUS = {
  0: { label: '未提交', value: 0 },
  1: { label: '待开票', value: 1 },
  2: { label: '待确认', value: 2 },
  3: { label: '已驳回', value: 3 },
  4: { label: '已开票', value: 4 }
};
// 个体开票状态
export const INVOICE_GT_STATUS = {
  1: { label: '未上传', value: 1 },
  2: { label: '已上传', value: 2 }
};
/** 申报方式: 1月度 2季度 */
export const DECLARE_METHOD = {
  1: { label: '月度', value: 1 },
  2: { label: '季度', value: 2 }
};
/** 代缴税金审核状态常量: 0待上传 1平台审核中 2审核通过 3审核驳回 */
export const PROXY_TAX_AUDIT_STATUS = {
  0: { label: '待上传', value: 0 },
  1: { label: '平台审核中', value: 1 },
  2: { label: '审核通过', value: 2 },
  3: { label: '审核驳回', value: 3 }
};
